exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select {\n    width: 30%;\n    z-index: 999;\n}\n\n.modal-backdrop.show {\n    opacity: 0.5 !important;\n    --bs-backdrop-bg: transparent;\n    background-color: transparent !important;\n}\n\n.txtmanname {\n    font-weight: bold;\n    font-family: initial;\n}\n\n.txtfulllastdata .modal-content {\n    /* width: 334px;\n    height: 355px; */\n    top: 40%;\n    left: 16%;\n}.customToastStyle  {\n    width: 500px;\n  };\n\n  .mode-booking {\n    color: blue; /* Color for bookings */\n}\n\n.mode-enquiry {\n    color: green; /* Color for enquiries */\n}\n\n\n.all_book{\nfont-size: 16px;\nfont-weight: 700;\n\n\n}", ""]);

// exports
